import React from "react";
import "../../App.css";
import i18next from "../../i18n";
import { Helmet } from "react-helmet-async";
import article_img from "../../images/articles/vladyslav-bahara-pc15IvTUgpc-unsplash.jpeg";

function FemStegUniversellUtforming() {
  return (
    <div className="min-h-screen bg-white">
      <Helmet>
        <title>{i18next.t("pages.articles.list.fiveSteps.title")}</title>
        <meta
          name="description"
          content={i18next.t("pages.articles.list.fiveSteps.description")}
        />
        <link
          rel="canonical"
          href="https://xperconsulting.no/artikler/fem-steg-universell-utforming-pdf"
        />
      </Helmet>
      <div className="container max-w-xl pt-36 justify-start items-center text-main-dark flex flex-col md:flex-row pb-24 md:gap-16">
        <div className="w-full md:w-3/5 text-left">
          <h1 className="text-5xl font-bold text-main-dark mb-4">
            {i18next.t("pages.articles.list.fiveSteps.title")}
          </h1>
          <p className="text-xl mb-2">
            {i18next.t("pages.articles.list.fiveSteps.description")}
          </p>
          <p className="text-lg text-secondary">
            {i18next.t("pages.articles.list.fiveSteps.date")}
          </p>
        </div>
        <img
          src={article_img}
          className="w-full md:w-2/5"
          alt={i18next.t("pages.articles.list.fiveSteps.imageAlt")}
        />
      </div>
      <div className="bg-gray">
        <div className="container max-w-xl text-xl text-left py-24 text-main-dark">
          <div className="max-w-sm">
            <a href="/artikler/tilgjengelighetsdirektivet" className="  hover:text-contrast-ink">
            <p>{i18next.t("pages.articles.list.fiveSteps.sections.intro.content")}</p>
            </a>
            <h2 className="text-3xl font-bold mt-12 mb-2">
              {i18next.t("pages.articles.list.fiveSteps.sections.steps.1.title")}
            </h2>
            <p>{i18next.t("pages.articles.list.fiveSteps.sections.steps.1.content")}</p>

            <h2 className="text-3xl font-bold mt-12 mb-2">
              {i18next.t("pages.articles.list.fiveSteps.sections.steps.2.title")}
            </h2>
            <p>{i18next.t("pages.articles.list.fiveSteps.sections.steps.2.content")}</p>

            <h2 className="text-3xl font-bold mt-12 mb-2">
              {i18next.t("pages.articles.list.fiveSteps.sections.steps.3.title")}
            </h2>
            <p>{i18next.t("pages.articles.list.fiveSteps.sections.steps.3.content")}</p>

            <h2 className="text-3xl font-bold mt-12 mb-2">
              {i18next.t("pages.articles.list.fiveSteps.sections.steps.4.title")}
            </h2>
            <p>{i18next.t("pages.articles.list.fiveSteps.sections.steps.4.content")}
              <br/>
            <a href="/docengine" className=" underline hover:text-contrast-ink mt-4">
            {i18next.t("pages.articles.list.fiveSteps.sections.steps.4.readMore")}
            </a>
            </p>
            

            <h2 className="text-3xl font-bold mt-12 mb-2">
              {i18next.t("pages.articles.list.fiveSteps.sections.steps.5.title")}
            </h2>
            <p>{i18next.t("pages.articles.list.fiveSteps.sections.steps.5.content")}</p>

            <h2 className="text-3xl font-bold mt-12 mb-2">
              {i18next.t("pages.articles.list.fiveSteps.sections.conclusion.title")}
            </h2>
            <p>{i18next.t("pages.articles.list.fiveSteps.sections.conclusion.content")}</p>
            <p className="mt-6">
              {i18next.t("pages.articles.list.fiveSteps.sections.conclusion.content2")}
              <a href="/skjema/kontakt-oss" className="font-bold underline hover:text-contrast-ink">
                {i18next.t("pages.articles.list.fiveSteps.sections.conclusion.cta")}
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FemStegUniversellUtforming;


